import { render, staticRenderFns } from "./arrow-up.vue?vue&type=template&id=c6babb6c&"
var script = {}
import style0 from "./arrow-up.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports